export function Divide(arregloOriginal){
    const LONGITUD_PEDAZOS = 6;
    let arregloDeArreglos = [];
    for (let i = 0; i < arregloOriginal.length; i += LONGITUD_PEDAZOS) {
        let pedazo = arregloOriginal.slice(i, i + LONGITUD_PEDAZOS);
        arregloDeArreglos.push(pedazo);
    }
    return arregloDeArreglos
}
